import { PageHeader } from '@/components/layout/PageHeader'

export function AgentsKnowledgePage() {
  return (
    <div className="flex flex-col gap-8 p-8">
      <PageHeader title="Manage your agents' knowledge base and training data" />
    </div>
  )
}
